import Carousel from "../Carousel/index";
import Card from "../CardService";
import AllService from "../AllService";
import Advertisement from "../Advertisement";
import Chefcard from "../Chef-card";
import Footer from "../../components/ErrorBoundary/Footer";
import Testimonial from "../Testimonial";
import { useEffect, useState } from "react";
import Loader from "../../components/Loader/index";
import axios from "axios";
import { toast } from "react-toastify";
import CityModal from "../../components/CitySelection";


const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [card, setCard] = useState([]);
  const [chefcard, setChefcard] = useState([]);
  const [ourstory, setOurstory] = useState({
    imageUrl: "",
    description: "",
    lable: "",
  });
  const [testimonial, setTestimonial] = useState([]);

  const [latitude, setLatitude] = useState<number | null>()
  const [longitude, setLongitude] = useState<number | null>()
  const [error, setError] = useState<string | null>()


  const fetchAddressFromCoords = async(latitude:any, longitude:any) => {
    const userId = localStorage.getItem('id');
    const token = localStorage.getItem('accessToken');
    console.log("userId",userId,token)
    try {
      let response = await axios.put(`${process.env.React_App_DYO_CHEF_UserInfo_URL}${userId}`,{latitude,longitude},{
        headers:{
          Authorization:`Bearer ${token}`
        }
      })
      const data = response.data;

    if (data.city === 'indore') {
      toast.success(data.message); 
    } else if(data.status === 200){
      // toast.error(data.message || 'Chef not available at your location');
      // toast.success('Chef not available at your location');
    }
    } catch (error) {
      console.log("errror",error)
    }
  }

  ///location code///
  useEffect(() => {
    const success = (position: GeolocationPosition) => {
      const { latitude, longitude } = position.coords;
      setLatitude(latitude);
      setLongitude(longitude);

      localStorage.setItem('latitude', latitude.toString());
      localStorage.setItem('longitude', longitude.toString());
      localStorage.setItem('locationPermission','true');
      console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
      fetchAddressFromCoords(latitude, longitude);
    };
    console.log(latitude)
    console.log(longitude)


    const errorHandler = (error: GeolocationPositionError) => {
      setError(error.message);
      localStorage.setItem('locationPermission','false');
      console.error(`Error getting geolocation: ${error.message}`);
    };

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(success, errorHandler);
    } else {
      setError("Geolocation is not supported by this browser.");
      console.log(error)
    }
  }, [latitude, longitude, error]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await fetch(
        `${process.env.React_App_DYO_CHEF_HOME_URL}`
      );
      const json = await data.json();
      console.log(json)
      setIsLoading(false);
      setCard(json.data.primeSegments);
      setChefcard(json.data.ourTeam);
      setOurstory(json.data.ourStory);
      setTestimonial(json.data.testimonial);
    } catch (error) {
      console.log("API Condition check", error)
    }

  };

  ////////
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const selectedCity = localStorage.getItem("selectedCity");
    if (!selectedCity) {
      setShowModal(true);
    }
  }, []);

  const handleCityConfirm = (city: string) => {
    localStorage.setItem("selectedCity", city.toLowerCase());
    console.log("City selected:", city);
  };

  return (
    <>
      <div className="text-center">
        {isLoading && <Loader />}
      </div>

      {/* <button onClick={() => setShowModal(true)} className="btn confirm">
        Choose City
      </button> */}

      <CityModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleCityConfirm}
      />

      {<Carousel />}
      {
        // <div
        //   onClick={() => {
        //     handleBooking("meal");
        //   }}
        // >
          <Card card={card} />
        // </div>
      }
      {<Advertisement advertisement={ourstory} />}
      {
        <div>
          <AllService />
        </div>
      }
      {<Chefcard chefcard={chefcard} />}
      {<Testimonial testimonial={testimonial} />}
      {<Footer />}
    </>
  );
};

export default Home;
